<template>
  <div class="bar">
    <div class="bar__info">
      <div class="bar__info--label">
        {{ data.AREA }}
      </div>
      <div class="bar__info--value">
        {{ data["QTY%"] + "%" }}
      </div>
    </div>
    <div class="bar__valuewrapper">
      <div
        class="bar__valuewrapper--filled"
        :style="{
          width: data['QTY%'] + '%',
        }"
      ></div>

      <div class="bar__valuewrapper--notFilled"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Bar",
  props: {
    data: {
      type: Object,
      required: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.bar {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  width: 100%;

  &__info {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    &--label {
      @include dida-S;
      color: $ui-white;
    }
    &--value {
      @include number-S;
      color: $primary-yellow;
    }
  }

  &__valuewrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 5px;
    width: 100%;
    // flex-grow: ;

    &--filled {
      background-color: $primary-yellow;
      height: 100%;
      transition: width .7s ease;
    }

    &--notFilled {
      background-color: $gray_02;
      flex-grow: 1;
      height: 100%;
    }
  }
}
</style>